import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import {
  fetchSchedules,
  selectedSessionID,
  blankSessionRatting,
  fetchRating,
  fetchAllRating,
  blankSessionCheckoutForm,
  fetchSessionChekoutForm,
  resetCurrentSessionFormToGlobalForm,
} from "LiveQAAction";
import {
  dynamicFormModal,
  updateFomeName,
  updateFormList,
  formEdited,
} from "FormBuilderAction";
import { fetchSettings } from "TicketAction";
import { showError, showSuccess } from "ReduxErrorBar";
import { screenHeightLeftFromTop, COMMON_FAIL_MESSAGE } from "Constants";
import NoContent, { NO_SESSION_RATTING } from "NoContent";
import SessionRatingItem from "./rating-item";
import SessionRatingCommenyItem from "./comment-list";
import ExportRatingExcelBtn from "./downloadratingcsv";
import AddFormBuilder from "AddFormBuilder";
import EditFormBuilder from "EditFormBuilder";
import LocaleStrings from "Languages";
import Loader from "Loader";
class Rating extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.blankSessionCheckoutForm();
    this.props.blankSessionRatting();
    this.getSchedules();
  }

  // First time Rating Graph
  getSchedules = () => {
    this.props.fetchSchedules(this.props.session, (response) => {
      if (response.success) {
        let sessions = response.resource.scheduleSession;
        if (sessions.length > 0) {
          setTimeout(() => {
            this.finalDataCall(sessions[0].sessionid);
            // this.getAllSession();
          }, 500);
        }
      }
    });
  };

  // Fetch Rating by changing schedule session
  getChangeLiveQA = (e) => {
    let sessionid = e.target.value;

    this.finalDataCall(sessionid);
  };

  finalDataCall = (sessionid) => {
    this.props.selectedSessionID(sessionid);
    this.props.fetchSessionChekoutForm(
      this.props.session,
      sessionid,
      (rateingResponse) => {}
    );
    this.props.fetchRating(
      this.props.session,
      sessionid,
      (rateingResponse) => {}
    );
    this.getAllSession();
  };

  callbackForm = () => {
    if (this.props.formBuilderModal.selectedSession) {
      this.finalDataCall(this.props.formBuilderModal.selectedSession);
    } else {
      this.props.fetchSettings(this.props.session);
    }
  };

  getAllSession = () => {
    this.props.fetchAllRating(
      this.props.session,
      this.props.allSessionId.resource,
      (rateingResponse) => {}
    );
  };

  addForm = (item) => {
    var fixedObj = [];

    // var newObj = [
    //   {
    //     key: "rating",
    //     defaultfields: true,
    //     isactive: true,
    //     required: false,
    //     label: "General Rating",
    //     name: "general",
    //     id: "general",
    //     header: "Rating",
    //     taborder: 1,
    //   },
    //   {
    //     key: "rating",
    //     defaultfields: true,
    //     isactive: true,
    //     required: false,
    //     label: "Speaking",
    //     name: "speaking",
    //     id: "speaking",
    //     header: "Rating",
    //     taborder: 2,
    //   },
    //   {
    //     key: "rating",
    //     defaultfields: true,
    //     isactive: true,
    //     required: false,
    //     label: "Presentation Content",
    //     name: "presentation",
    //     id: "presentation",
    //     header: "Rating",
    //     taborder: 3,
    //   },
    //   {
    //     key: "textinput",
    //     defaultfields: true,
    //     isactive: true,
    //     required: false,
    //     maxlen: "1000",
    //     label: "Comment",
    //     name: "comment",
    //     id: "comment",
    //     header: "Input",
    //     taborder: 4,
    //   },
    // ];

    // var newObj = [
    //   {
    //     key: "radiobuttons",
    //     defaultfields: true,
    //     isactive: true,
    //     required: false,
    //     hasCondition: false,
    //     label: "How satisfied are you with the Session ?",
    //     name: "aboutsession",
    //     id: "aboutsession",
    //     header: "Radio Button",
    //     taborder: 1,
    //     options: [
    //       {
    //         value: "Very Satisfied",
    //         text: "Very Satisfied",
    //         displayfields: "",
    //       },
    //       { value: "Satisfied", text: "Satisfied", displayfields: "" },
    //       { value: "Average", text: "Average", displayfields: "" },
    //       { value: "Dissatisfied", text: "Dissatisfied", displayfields: "" },
    //       {
    //         value: "Very Dissatisfied",
    //         text: "Very Dissatisfied",
    //         displayfields: "",
    //       },
    //     ],
    //   },
    //   {
    //     key: "radiobuttons",
    //     defaultfields: true,
    //     isactive: true,
    //     required: false,
    //     hasCondition: false,
    //     label: "How satisfied are you with the speaker delivery ?",
    //     name: "aboutspeaker",
    //     id: "aboutspeaker",
    //     header: "Radio Button",
    //     taborder: 2,
    //     options: [
    //       {
    //         value: "Very Satisfied",
    //         text: "Very Satisfied",
    //         displayfields: "",
    //       },
    //       { value: "Satisfied", text: "Satisfied", displayfields: "" },
    //       { value: "Average", text: "Average", displayfields: "" },
    //       { value: "Dissatisfied", text: "Dissatisfied", displayfields: "" },
    //       {
    //         value: "Very Dissatisfied",
    //         text: "Very Dissatisfied",
    //         displayfields: "",
    //       },
    //     ],
    //   },
    //   {
    //     key: "radiobuttons",
    //     defaultfields: true,
    //     isactive: true,
    //     required: false,
    //     hasCondition: false,
    //     label: "How relevant and helpful do you think it was for you ?",
    //     name: "helpfullforyou",
    //     id: "helpfullforyou",
    //     header: "Radio Button",
    //     taborder: 3,
    //     options: [
    //       {
    //         value: "Very Much Relevant and Useful",
    //         text: "Very Much Relevant and Useful",
    //         displayfields: "",
    //       },
    //       {
    //         value: "Little Relevant and Useful",
    //         text: "Little Relevant and Useful",
    //         displayfields: "",
    //       },
    //       {
    //         value: "Not at All Relevant or Useful",
    //         text: "Not at All Relevant or Useful",
    //         displayfields: "",
    //       },
    //     ],
    //   },
    //   {
    //     key: "textinput",
    //     defaultfields: true,
    //     isactive: true,
    //     required: false,
    //     maxlen: "1000",
    //     label: "What were your key learning from this session ?",
    //     name: "keylearning",
    //     id: "keylearning",
    //     header: "Input",
    //     taborder: 4,
    //   },
    //   {
    //     key: "textinput",
    //     defaultfields: true,
    //     isactive: true,
    //     required: false,
    //     maxlen: "1000",
    //     label: "How can we improve this session further ?",
    //     name: "sessionimprove",
    //     id: "sessionimprove",
    //     header: "Input",
    //     taborder: 5,
    //   },
    //   {
    //     key: "radiobuttons",
    //     defaultfields: true,
    //     isactive: true,
    //     required: false,
    //     hasCondition: false,
    //     label: "Would you recommend this session to others ?",
    //     name: "recommendsession",
    //     id: "recommendsession",
    //     header: "Radio Button",
    //     taborder: 6,
    //     options: [
    //       { value: "Yes", text: "Yes", displayfields: "" },
    //       { value: "No", text: "No", displayfields: "" },
    //       { value: "Maybe", text: "Maybe", displayfields: "" },
    //     ],
    //   },
    //   {
    //     key: "textinput",
    //     defaultfields: true,
    //     isactive: true,
    //     required: false,
    //     maxlen: "1000",
    //     label: "Any Comment",
    //     name: "comment",
    //     id: "comment",
    //     header: "Input",
    //     taborder: 7,
    //   },
    // ];

    var formName = "Session Rating Form";
    var newObj = JSON.parse(item.formjson); // Session Default Rating Form will be Global Updated Session Rating Form, Not Default above Form (Changed by VKP on 07/06/23)

    this.props.dynamicFormModal({
      key: "add",
      showModal: true,
      category: "sessionrating",
      fixedFields: fixedObj,
      selectedSession: this.props.selectedSession,
    });
    this.props.updateFomeName(formName);
    this.props.updateFormList(newObj, [], "new");
  };

  editForm(item, type = "") {
    let formNameEdit = item.formname;
    let newObj = JSON.parse(item.formjson);
    let formtype = item.formtype;
    let fixedObj = [];

    this.props.dynamicFormModal({
      key: "edit",
      showModal: true,
      category: formtype,
      fixedFields: fixedObj,
      formDetails: item,
      ...(type === "particular"
        ? { selectedSession: this.props.selectedSession }
        : {}),
    });
    this.props.updateFomeName(formNameEdit); // Form Name
    this.props.updateFormList(newObj, [], "samearray"); // Updating redux with editing from json
    this.props.formEdited(false); // This is used for edit form
  }

  resetToDefault(sessionid) {
    // console.log("sessionid :- ", sessionid);

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body">
            <h1>
              {
                LocaleStrings.polls_qa_rating_reset_session_rating_form_confirmation_title
              }
            </h1>
            <p>
              {
                LocaleStrings.polls_qa_rating_reset_session_rating_form_confirmation_subtitle
              }
            </p>

            <div className="react-confirm-alert-button-group">
              <button
                type="button"
                onClick={() => {
                  this.props.resetCurrentSessionFormToGlobalForm(
                    this.props.session,
                    sessionid,
                    (res) => {
                      if (res.success === 1) {
                        this.finalDataCall(sessionid);
                        setTimeout(() => {
                          this.props.showSuccess(
                            LocaleStrings.polls_qa_rating_reset_session_rating_form_success
                          );
                          onClose();
                        }, 700);
                      } else if (res.success === 2) {
                        this.props.showError(
                          LocaleStrings.polls_qa_rating_reset_session_rating_form_error_noform
                        );
                      } else {
                        this.props.showError(COMMON_FAIL_MESSAGE);
                      }
                    }
                  );
                }}
              >
                {LocaleStrings.button_ok}
              </button>
              <button onClick={onClose}>{LocaleStrings.button_cancel}</button>
            </div>
          </div>
        );
      },
    });
  }

  exportRating = (JSONData, ShowLabel) => {
    this.JSONToCSVConvertor(JSONData, ShowLabel);
  };

  exportAllRatings = (allRatingData, ShowLabel) => {
    this.AllRatingsJSONToCSVConvertor(allRatingData, ShowLabel);
  };

  JSONToCSVConvertor(JSONData, ShowLabel) {
    // If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    var XLSX = require("xlsx");

    /* Create a new empty workbook, then add the worksheet */
    let wb = XLSX.utils.book_new();

    _.map(JSONData, (item, index) => {
      /* Create a worksheet */
      var ws = XLSX.utils.json_to_sheet(item);

      var sheetName = index.replace(/[\/\\:\[\]*?]/g, "_"); // Sheet name cannot contain ': \ / ? * [ ]' so replacing with '_' and also can not contain more than 31 chars
      if (sheetName.length > 30) {
        sheetName = sheetName.substr(0, 28) + "...";
      }

      XLSX.utils.book_append_sheet(wb, ws, sheetName);
    });

    /* Generate xlsx files */
    XLSX.writeFile(wb, "ratings.xlsx");
  }

  AllRatingsJSONToCSVConvertor(allRatingData, ShowLabel) {
    // If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    var XLSX = require("xlsx");
    // console.log("allRatingData :- ", allRatingData);

    /* Create a new empty workbook, then add the worksheet */
    let wb = XLSX.utils.book_new();

    _.forEach(allRatingData, (item, index) => {
      var ws = XLSX.utils.json_to_sheet(item);

      var sheetName = index.replace(/[\/\\:\[\]*?]/g, "_"); // Sheet name cannot contain ': \ / ? * [ ]' so replacing with '_' and also can not contain more than 31 chars
      if (sheetName.length > 30) {
        sheetName = sheetName.substr(0, 28) + "...";
      }

      XLSX.utils.book_append_sheet(wb, ws, sheetName);
    });

    /* Generate xlsx files */
    XLSX.writeFile(wb, "allratings.xlsx");
  }

  renderRatings = () => {
    let { settingData, singleSessionCheckouForm, singleSessionRatings } =
      this.props;

    let formItems =
      settingData &&
      settingData.length > 0 &&
      settingData[0].event_forms_by_sesseionratingformid
        ? JSON.parse(
            settingData[0].event_forms_by_sesseionratingformid.formjson
          )
        : [];

    if (singleSessionCheckouForm.data.sessionratingid) {
      formItems = JSON.parse(
        singleSessionCheckouForm.data.event_forms_by_sessionratingid.formjson
      );
    }
    // console.log("formItems :- ", formItems);

    let savedForm =
      singleSessionRatings &&
      singleSessionRatings.resource &&
      singleSessionRatings.resource.length > 0
        ? singleSessionRatings.resource
        : [];
    // console.log("savedForm :- ", savedForm);

    let savedRatingData = [];
    if (savedForm.length > 0) {
      _.map(savedForm, (item) => {
        let responses =
          item.response && item.response != "" ? JSON.parse(item.response) : [];
        let array = [];

        _.map(responses, (val) => {
          let obj = {};

          if (val.key === "rating") {
            obj = { name: val.name, value: parseInt(val.value) };

            savedRatingData.push(obj);
          }
        });

        // savedRatingData.push(array);
      });
    }

    return _.map(formItems, (item, index) => {
      if (item.key === "rating") {
        let filter = _.filter(savedRatingData, (obj) => {
          return obj.name == item.name;
        });

        return (
          <SessionRatingItem
            key={`key-${index}`}
            printList={item}
            total={savedForm.length}
            ratings={filter}
          />
        );
      }
    });
  };

  /**
   * =============================================================================================
   */

  render() {
    let {
      deviceSize,
      scheduleSessions,
      singleSessionRatings,
      settingData,
      singleSessionCheckouForm,
      formBuilderModal,
      selectedSession,
    } = this.props;
    let total =
      singleSessionRatings && singleSessionRatings.count
        ? singleSessionRatings.count
        : 0;

    // schedules all sesssion
    let sessionArray = [];
    if (scheduleSessions && scheduleSessions.scheduleSession) {
      scheduleSessions.scheduleSession.map((object, index) => {
        sessionArray.push(
          <option key={`${object.sessionid}-${index}`} value={object.sessionid}>
            {object.scheduledate} | {object.trackname} | {object.title}
          </option>
        );
      });
    }
    // console.log("selectedSession :- ", selectedSession);
    // console.log("scheduleSessions :- ", scheduleSessions);
    // console.log("singleSessionRatings :- ", singleSessionRatings);
    // console.log("settingData :- ", settingData);
    // console.log("singleSessionCheckouForm :- ", singleSessionCheckouForm);

    return (
      <div>
        <div className="content-header-bar">
          <div className="vertical-align-center">
            <select
              className=" dropdown-height-border"
              style={{ maxWidth: 800 }}
              onChange={this.getChangeLiveQA}
            >
              {sessionArray.length > 0 ? (
                sessionArray
              ) : (
                <option key="NO" value="">
                  {LocaleStrings.polls_qa_no_session_added}
                </option>
              )}
            </select>
          </div>

          <>
            {settingData &&
            settingData.length > 0 &&
            singleSessionRatings &&
            singleSessionRatings.resource ? (
              <ul className="header-buttons">
                {/* Global Rating Form */}
                <li>
                  <div className="vertical-align-center gap-3">
                    <OverlayTrigger
                      key={`reting-update-for-current-session`}
                      placement="left"
                      overlay={
                        <Tooltip id={`reting-update-for-current-session`}>
                          <div className="custom-text1-white-normal">
                            {
                              LocaleStrings.polls_qa_rating_text_update_global_rating_form_info
                            }
                          </div>
                        </Tooltip>
                      }
                    >
                      <img
                        src="../../style/images/header-icons/infoicon.png"
                        className="ml-10 pointer"
                        alt="info icon"
                      />
                    </OverlayTrigger>
                    <button
                      type="button"
                      className="btn btn-custom-blue"
                      onClick={() =>
                        this.editForm(
                          settingData[0].event_forms_by_sesseionratingformid,
                          "global"
                        )
                      }
                    >
                      <i className="fa fa-pencil i-custom-ms"></i>
                      {
                        LocaleStrings.polls_qa_rating_text_update_global_rating_form
                      }
                    </button>
                  </div>
                </li>
                <li>
                  <ExportRatingExcelBtn
                    JSONToCSVConvertor={this.exportRating}
                    AllRatingCSVConverter={this.exportAllRatings}
                    getAllSession={this.getAllSession}
                  />
                </li>
              </ul>
            ) : (
              ""
            )}
          </>
        </div>

        <div className="vertical-align-center-justify-between border-bottom p-3">
          <h4 data-hook="total-rating-count">
            {LocaleStrings.total} {total}{" "}
            {LocaleStrings.polls_qa_rating_text_user_rating}
          </h4>

          {/* Current Session Rating Form */}
          {settingData &&
          settingData.length > 0 &&
          singleSessionCheckouForm &&
          singleSessionCheckouForm.data &&
          singleSessionRatings &&
          singleSessionRatings.resource ? (
            <>
              {singleSessionCheckouForm.data.sessionratingid ? (
                <div>
                  {/* Current Session Rating Form Reset */}
                  <div className="vertical-align-center gap-3">
                    <OverlayTrigger
                      key={`reting-update-for-current-session`}
                      placement="left"
                      overlay={
                        <Tooltip id={`reting-update-for-current-session`}>
                          <div className="custom-text1-white-normal">
                            {
                              LocaleStrings.polls_qa_rating_text_reset_session_rating_form_info
                            }
                          </div>
                        </Tooltip>
                      }
                    >
                      <img
                        src="../../style/images/header-icons/infoicon.png"
                        className="pointer"
                        alt="info icon"
                      />
                    </OverlayTrigger>

                    <div
                      className="custom-text3-theme-medium pointer text-decoration-underline"
                      onClick={() =>
                        this.resetToDefault(
                          singleSessionCheckouForm.data.sessionid
                        )
                      }
                    >
                      {
                        LocaleStrings.polls_qa_rating_text_reset_session_rating_form
                      }
                    </div>
                  </div>

                  {/* Current Session Rating Form Edit */}
                  <div className="vertical-align-center gap-3">
                    <OverlayTrigger
                      key={`reting-update-for-current-session`}
                      placement="left"
                      overlay={
                        <Tooltip id={`reting-update-for-current-session`}>
                          <div className="custom-text1-white-normal">
                            {
                              LocaleStrings.polls_qa_rating_text_update_session_rating_form_info
                            }
                          </div>
                        </Tooltip>
                      }
                    >
                      <img
                        src="../../style/images/header-icons/infoicon.png"
                        className="pointer"
                        alt="info icon"
                      />
                    </OverlayTrigger>
                    <div
                      className="custom-text3-theme-medium pointer text-decoration-underline"
                      onClick={() =>
                        this.editForm(
                          singleSessionCheckouForm.data
                            .event_forms_by_sessionratingid,
                          "particular"
                        )
                      }
                    >
                      {
                        LocaleStrings.polls_qa_rating_text_update_session_rating_form
                      }
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  {/* Current Session Rating Form Add */}
                  <div className="vertical-align-center gap-3">
                    <OverlayTrigger
                      key={`reting-update-for-current-session`}
                      placement="left"
                      overlay={
                        <Tooltip id={`reting-update-for-current-session`}>
                          <div className="custom-text1-white-normal">
                            {
                              LocaleStrings.polls_qa_rating_text_update_session_rating_form_info
                            }
                          </div>
                        </Tooltip>
                      }
                    >
                      <img
                        src="../../style/images/header-icons/infoicon.png"
                        className="pointer"
                        alt="info icon"
                      />
                    </OverlayTrigger>

                    <div
                      className="custom-text3-theme-medium pointer text-decoration-underline"
                      onClick={() =>
                        this.addForm(
                          settingData[0].event_forms_by_sesseionratingformid
                        )
                      }
                    >
                      {
                        LocaleStrings.polls_qa_rating_text_update_session_rating_form
                      }
                    </div>
                  </div>
                </>
              )}
            </>
          ) : (
            ""
          )}
        </div>
        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - (screenHeightLeftFromTop + 72) }}
        >
          {scheduleSessions && scheduleSessions.scheduleSession ? (
            <>
              {scheduleSessions.scheduleSession.length > 0 ? (
                <>
                  {settingData &&
                  settingData.length > 0 &&
                  singleSessionCheckouForm &&
                  singleSessionCheckouForm.data &&
                  singleSessionRatings &&
                  singleSessionRatings.resource ? (
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row">{this.renderRatings()}</div>
                      </div>

                      {total > 0 ? (
                        <div className="col-md-12 mt-10">
                          <hr />

                          <SessionRatingCommenyItem />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    <div className="loader-container">
                      <Loader />
                      <div className="loader-info">
                        {LocaleStrings.preparingrating}
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <NoContent contentType={NO_SESSION_RATTING} />
              )}
            </>
          ) : (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{LocaleStrings.preparingrating}</div>
            </div>
          )}
        </div>

        {formBuilderModal &&
        formBuilderModal.showModal &&
        formBuilderModal.key === "add" ? (
          <AddFormBuilder calledFrom={this.callbackForm} />
        ) : (
          ""
        )}

        {formBuilderModal &&
        formBuilderModal.showModal &&
        formBuilderModal.key === "edit" ? (
          <EditFormBuilder calledFrom={this.callbackForm} />
        ) : (
          ""
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    deviceSize: state.deviceSize,
    session: state.session,
    allSessionId: state.allSessionId,
    scheduleSessions: state.scheduleSessions.resource,
    selectedSession: state.selectedSession.resource,
    settingData: state.SettingData.resource,
    singleSessionCheckouForm: state.singleSessionCheckouForm,
    singleSessionRatings: state.singleSessionRatings,
    formBuilderModal: state.formBuilderModal,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  fetchSchedules,
  fetchAllRating,
  selectedSessionID,
  blankSessionRatting,
  fetchRating,
  blankSessionCheckoutForm,
  fetchSessionChekoutForm,
  dynamicFormModal,
  updateFomeName,
  updateFormList,
  formEdited,
  fetchSettings,
  resetCurrentSessionFormToGlobalForm,
})(Rating);
